export default __webpack_public_path__ + "static/media/ARPHICPL.c6b40c6c.TXT";